<template>
  <div>

    <v-card class="ma-2 pa-2">
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
    >
      <template v-slot:default="props">
        <li :key="item.name" v-for="item in props.items">
          <img :src="'https://developer-test.royalantenna.com/wp-content/themes/ajaira/db_form/upload/image/'+item.name" style="max-height:140px;width:auto;max-width:100%;" />
          {{ item.name }}
        </li>
      </template>
    </v-data-iterator>

    </v-card>

    <!-- <ul>
    <li :key="item" v-for="item in list">      <img :src="'https://developer-test.royalantenna.com/wp-content/themes/ajaira/db_form/upload/image/'+item" width=200 />
      {{item}}
    </li>
</ul> -->
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      itemsPerPage: 10,

      // list : [],

      items: [],
    };
  },

  computed: {},

  methods: {
    getImageBBS() {
      axios
        .get(process.env.VUE_APP_IMAGE_BBS, {
          params: { year: "2022", month: "04" },
        })
        .then((response) => {
          console.log(response);
          var self = this;
          response.data.forEach((element) => {
            self.items.push({ name: element });
          });

          // console.log(this.list);
        });
    },
  },

  watch: {},

  created: function() {
    this.getImageBBS();
  },

  beforeCreate: function() {},
};
</script>

<style>
ul {
  display: flex;
  flex-wrap: wrap;
}
li {
  display: inline-block;
  width: 20%;
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin: 20px auto;
  min-height:180px;
}
/* .v-btn {
  justify-content: left !important;
} */
</style>
